<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>
      {{ titleinfo }}
    </div>
    <div class="content">
      <div class="set_flexwrap">
        <div class="flex_wrap">
          <el-form
            ref="form"
            :rules="
              formdata.type === 2
                ? rules2
                : formdata.type === 3
                ? rules3
                : rules
            "
            :model="formdata"
            label-width="120px"
          >
            <div class="form_splititem">商品类别</div>
            <el-form-item>
              <template v-if="companyIndex.is_ai_img">
                <el-radio-group v-model="formdata.type">
                  <el-radio
                    v-for="(item, index) in goodtype"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </template>
              <template v-if="!companyIndex.is_ai_img">
                <el-radio-group v-model="formdata.type">
                  <el-radio
                    v-for="(item, index) in goodtypeNotAi"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </template>
              <p>
                如果是VIP会员、充值、录制课程、录制音频视频等，请选择"虚拟商品"类别。（选择后不可更改）
                虚拟商品暂不支持购买、分销
              </p>
            </el-form-item>
            <div class="form_splititem">基本信息</div>
            <el-form-item
              v-if="formdata.type === 2"
              class="whd-form-item"
              label="AI主题类别"
              prop="employee_id"
            >
              <el-select
                v-model="formdata.aimainType"
                class="w160"
                placeholder="请选择"
                @change="aiMainChange"
              >
                <el-option
                  v-for="item in aiMainData"
                  :key="item.id"
                  :label="item.goods_catalog"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品名称" prop="goods_name">
              <el-input
                type="text"
                v-model="formdata.goods_name"
                maxlength="30"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="商品分类" prop="cat_id">
              <el-select
                v-model="formdata.cat_label"
                placeholder="请选择分类"
                class="w555"
                popper-class="whd-select-dropdown"
                multiple
                @remove-tag="removeTag"
              >
                <el-option :value="formdata.cat_id" style="height: auto">
                  <el-tree
                    :data="cateoptions"
                    show-checkbox
                    node-key="id"
                    ref="tree"
                    :default-checked-keys="formdata.cat_id"
                    :check-strictly="true"
                    highlight-current
                    :props="defaultProps"
                    @check-change="handleCheckChange"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品图片" prop="album">
              <div v-if="formdata.album.length > 0">
                <draggable
                  v-model="formdata.album"
                  :options="{ draggable: '.draggableItem', animation: 150 }"
                  :move="getdata"
                  @update="datadragEnd"
                  class="draggable-body-list whd-draggable-list"
                >
                  <transition-group class="draggable-body">
                    <div
                      v-for="(item, index) in formdata.album"
                      :key="item"
                      class="draggableItem"
                      :style="{
                        backgroundImage: 'url(' + item + ')',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                      }"
                      :class="currentindex == index ? 'activedraggable' : ''"
                      @click.stop="indexLine(index)"
                    >
                      <i
                        class="el-icon-circle-close"
                        @click="detelFn(index)"
                      ></i>
                    </div>
                  </transition-group>
                </draggable>
              </div>
              <div class="addicon">
                <div class="el-upload el-upload--text" @click="showCropper">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
                <div class="el-upload__tip">
                  第一张默认为封面,可以拖拽图片调整顺序，最多上传5张，尺寸640*640比例，大小10M以内。
                </div>
              </div>
            </el-form-item>
            <el-form-item label="介绍视频">
              <el-upload
                class="addicon"
                :action="uploadvideourl"
                :data="data_"
                :show-file-list="false"
                :limit="1"
                :on-success="handlevideoSuccess"
                :before-upload="beforevideoUpload"
              >
                <div v-if="formdata.video !== ''">
                  <video
                    :src="formdata.video"
                    class="avatar"
                    controls="controls"
                  >
                    您的浏览器不支持视频播放
                  </video>
                  <span class="detelBox" @click.stop="handlevideoRemove"
                    >删除</span
                  >
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  介绍视频默认放在商品主图中第一屏，如有需要请上传，最多上传一个（仅支持5M以内的MP4格式）
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item
              class="whd-form-item"
              label="产品详情图片"
              prop="goods_detail"
            >
              <uploaddrag
                v-if="formdata.goods_detail"
                :picture="formdata.goods_detail"
                @uploadsucess="uploaddetail"
                limit="25"
                ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  上传与商品详情有关图片，可以拖拽图片调整顺序，最多上传25张，
                  图片宽高均不超过4000，宽不低于640,宽高比不超过1:25，单张不超过10M
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item
              class="whd-form-item"
              label="AI底图"
              prop="draw_img"
              v-if="formdata.type === 2"
            >
              <uploaddrag
                v-if="formdata.draw_img"
                :picture="formdata.draw_img"
                @uploadsucess="uploaddetaildraw"
                limit="1"
                ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  上传AI定制底图，最多上传1张，
                  图片宽高均不超过4000，宽不低于640,宽高比不超过1:25，单张不超过10M
                </div>
              </uploaddrag>
            </el-form-item>

            <el-form-item
              class="whd-form-item"
              label="所属员工"
              prop="employee_id"
              v-if="formdata.type === 3"
            >
              <el-select
                v-model="formdata.employee_id"
                class="w160"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in membertions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品排序">
              <el-input
                type="text"
                v-model="formdata.order_desc"
                class="w160"
              ></el-input>
            </el-form-item>
            <template
              v-if="
                formdata.type === 0 ||
                formdata.type === 2 ||
                formdata.type === 3
              "
            >
              <el-form-item label="是否允许支付">
                <el-radio-group v-model="formdata.is_pay">
                  <el-radio
                    v-for="(item, index) in ispay"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}
                  </el-radio>
                </el-radio-group>
                <span class="pay_tip" v-if="formdata.is_pay === 0 && ispayshow">
                  线上支付商品需先配置微信支付，
                  <span class="go_set" @click="goset">前往配置></span>
                </span>
              </el-form-item>
              <div class="form_splititem">价格库存</div>
              <!-- 仅线上展示 -->
              <div v-if="formdata.is_pay === 1">
                <el-form-item label="价格展示自定义">
                  <el-radio-group v-model="formdata.show_type">
                    <el-radio
                      :label="item.value"
                      v-for="(item, index) in showtype"
                      :key="index"
                      class="linelong"
                    >
                      <div class="radio_item" v-if="item.value === 0">
                        <el-input
                          type="text"
                          v-model="formdata.reference1"
                          class="w160"
                          maxlength="4"
                        ></el-input>
                        <el-input
                          type="text"
                          v-model="formdata.reference_price"
                          class="w160 ml10"
                          maxlength="10"
                        ></el-input>
                        <p class="mt-5">
                          必填；支持修改，分别限制4字，10字。设置参考：参考价格
                          1万-10万/预估价格 ￥999起
                        </p>
                      </div>
                      <div class="radio_item" v-if="item.value === 1">
                        <el-input
                          type="text"
                          v-model="formdata.reference2"
                          class="w160"
                          maxlength="4"
                        ></el-input>
                        <p class="mt-5">
                          必填；支持修改,限制4字。设置参考：价格面议/线下定制
                        </p>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <!-- 暂时注释，待接口调整后开启 -->
              <!-- 关联表单 仅线上展示 -->
              <!-- <template v-if="formdata.is_pay===1">
                <div class="form_splititem">关联表单</div>
                <el-form label-width="120px">
                  <el-form-item label="关联表单">
                    <div class="weui-cell" style="padding: 0">
                      <div class="weui-cell__hd mr-10" v-if="form_name">{{form_name}}</div>
                      <div class="weui-cell__hd mr-10"><el-button plain @click="openFormList">{{form_name?'重新选择':'选择表单'}}</el-button></div>
                      <div class="weui-cell__hd" v-if="form_name"><el-button type="text" @click="deleteForm">删除表单</el-button></div>
                      <div class="weui-cell__bd"></div>
                    </div>
                  </el-form-item>
                  <el-form-item label="按钮名称">
                    <el-input type="text" v-model="form_btn" class="w160" maxlength="4" show-word-limit></el-input>
                  </el-form-item>
                </el-form>
              </template> -->
              <!-- 支持线上支付 -->
              <div v-if="formdata.is_pay === 0">
                <!-- is_attr【0：单规格；1：多规格】 -->
                <el-form-item label="规格设置">
                  <el-radio-group
                    v-model="formdata.is_attr"
                    @change="changeattr"
                  >
                    <el-radio
                      v-for="(item, index) in isattr"
                      :label="item.value"
                      :key="index"
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="销售单位" prop="unit">
                  <el-input
                    type="text"
                    v-model="formdata.unit"
                    class="w160"
                  ></el-input>
                  <p class="el-upload__tip" style="line-height: 1.2">
                    请输入计量单位，如件、套、斤等
                  </p>
                </el-form-item>
                <el-form-item
                  class="whd-form-item"
                  label="定制内容"
                  prop="make_id"
                  v-if="formdata.type === 3 && formdata.is_attr === 0"
                >
                  <!-- <el-select v-model="formdata.make_id" class="w160" placeholder="请选择">
                    <el-option
                            v-for="item in spections"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                  </el-select> -->
                  <!-- <span
                    style="color: #29a7f4; cursor: pointer"
                    @click="customBtnAdd({ attr_make_id: formdata.make_id })"
                  >
                    <template v-for="(item, index) in spections">
                      <template v-if="item.id == formdata.make_id">
                        {{ item.name }}
                      </template>
                    </template>
                  </span>
                  <el-button @click="selectcustomBtnAdd({}, -1)">
                    选择定制规格
                  </el-button> -->
                  <el-button @click="selectcustomBtn()">
                    选择定制规格
                  </el-button>
                </el-form-item>
                <!-- 单规格 -->
                <div v-if="formdata.is_attr === 0">
                  <!-- <el-form-item label="市场价">
                    <el-input type="text" v-model="formdata.cost" class="w160" maxlength="14"></el-input>
                    元
                  </el-form-item>
                  <el-form-item label="售价" prop="shop_price">
                    <el-input type="text" v-model="formdata.shop_price" class="w160"></el-input>
                    元
                  </el-form-item> -->
                  <el-form-item label="库存" prop="goods_number">
                    <el-input
                      type="text"
                      v-model="formdata.goods_number"
                      class="w160"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item label="库存编号">
                    <el-input type="text" v-model="formdata.goods_number" class="w160"></el-input>
                  </el-form-item>-->
                  <el-form-item prop="shop_price" label="价格形式">
                    <el-radio-group
                      class="whd-price"
                      v-model="formdata.show_price"
                      @change="changetype"
                    >
                      <el-radio label="0">
                        <div class="weui-cell mb20">
                          <div class="weui-cell__hd w100">一口价</div>
                          <div class="weui-cell__hd">价格</div>
                          <div class="weui-cell__hd">
                            <el-input
                              v-if="formdata.show_price == 0"
                              type="text"
                              :disabled="
                                formdata.show_price == 0 ? false : true
                              "
                              v-model="formdata.shop_price"
                              class="w105"
                              onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                            ></el-input>
                            <el-input
                              v-else
                              type="text"
                              disabled
                              class="w105"
                            ></el-input>
                          </div>
                          <div class="weui-cell__bd">元</div>
                        </div>
                      </el-radio>
                      <el-radio label="1">
                        <div class="weui-cell">
                          <div class="weui-cell__hd w100">显示折扣价</div>
                          <div class="weui-cell__hd">原价</div>
                          <div class="weui-cell__hd">
                            <el-input
                              type="text"
                              :disabled="
                                formdata.show_price == 1 ? false : true
                              "
                              v-model="formdata.cost"
                              class="w105"
                              maxlength="14"
                              onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                            ></el-input>
                          </div>
                          <div class="weui-cell__hd">元</div>
                          <div class="weui-cell__hd w80 whd-tright">现价</div>
                          <div class="weui-cell__hd">
                            <el-input
                              v-if="formdata.show_price == 1"
                              type="text"
                              v-model="formdata.shop_price"
                              class="w105"
                              onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                            ></el-input>
                            <el-input
                              v-else
                              type="text"
                              disabled
                              class="w105"
                            ></el-input>
                          </div>
                          <div class="weui-cell__bd">元</div>
                        </div>
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item prop="points" label="">
                    <span class="el-form-item__label"
                      >支付成功后获取积分数量</span
                    >
                    <el-input
                      type="text"
                      v-model="formdata.points"
                      class="w105"
                    ></el-input>
                    <p class="el-upload__tip" style="line-height: 1.2">
                      建议积分数量比例为：事件购买价格*100=积分数量（例如商品9.9，那么建议获取积分数量为9.9*100=990）
                    </p>
                  </el-form-item>
                </div>
                <el-form-item label="初始化销量" prop="false_sales">
                  <el-input
                    type="number"
                    v-model="formdata.false_sales"
                    placeholder="请输入初始化销量"
                    class="w160"
                  ></el-input>
                  <p class="el-upload__tip" style="line-height: 1.2">
                    不输入则表示不显示初始化销量，展示销量=初始化销量+实际销量
                  </p>
                </el-form-item>
                <!-- 多规格 -->
                <div v-if="formdata.is_attr === 1">
                  <el-form-item label="商品类目" prop="attr_cate">
                    <!-- {{ formdata.attr_cate_name }} -->
                    <el-select
                      v-model="specification"
                      placeholder="请选择"
                      @change="specificationChange"
                    >
                      <el-option
                        v-for="item in specificationList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <el-button @click="selectSpecil">新增</el-button> -->
                    <el-button
                      @click="_addSpecil"
                      style="margin-left: 10px"
                      :icon="
                        specificationId === null
                          ? 'el-icon-plus'
                          : 'el-icon-edit'
                      "
                      type="primary"
                    >
                      {{ specificationId === null ? "新增" : "编辑" }}
                    </el-button>
                  </el-form-item>
                  <el-form-item>
                    <!-- <div
                      class=""
                      
                    > -->
                    <!-- addSpecilShow -->
                    <goodsSpecification
                      class="goodsSpecification"
                      v-if="addSpecilShow"
                      :id="specificationId"
                      @specificationsuccess="_specificationsuccess"
                      @cancel="addSpecilShow = false"
                    />
                    <!-- </div> -->
                  </el-form-item>
                  <!-- <el-form-item label="商品类目" prop="attr_cate">
                    <el-button @click="addSpecil">新增规格</el-button>
                  </el-form-item>
                  <el-form-item label="商品类目" prop="attr_cate">
                    <el-select
                            v-model="formdata.attr_cate"
                            class="w160"
                            placeholder="请选择"
                            @change="changeattrcate"
                    >
                      <el-option
                              v-for="(item,index) in attrcateoptions"
                              :key="index"
                              :label="item.name"
                              :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item> -->
                  <el-form-item
                    v-for="(attritem, index) in attrinfo"
                    :key="index"
                    :label="attritem.name"
                    required
                  >
                    <el-checkbox-group
                      v-model="attritem.checkattrList"
                      @change="getattrtable"
                    >
                      <el-checkbox
                        v-for="(subattritem, index) in attritem.attr"
                        :label="subattritem.id"
                        :key="index"
                        >{{ subattritem.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="市场价">
                    <el-input
                      type="text"
                      v-model="formdata.cost"
                      class="w160"
                    ></el-input>
                  </el-form-item>
                  <el-table
                    class="mb20"
                    :data="attrtable"
                    border
                    style="width: 100%"
                    v-if="tablehead.length > 0"
                  >
                    <el-table-column
                      min-width="80"
                      :label="hitem.label"
                      v-for="(hitem, index) in tablehead"
                      :key="index"
                    >
                      <template slot-scope="scope">{{
                        scope.row[hitem.label].name
                      }}</template>
                    </el-table-column>
                    <el-table-column min-width="220" align="right">
                      <template slot="header" slot-scope="scope">
                        <div class="header_label w80 whd-tright">售价</div>
                        <el-input
                          type="text"
                          v-model="attr_price"
                          class="w100"
                          size="mini"
                          style="margin: 0 8px"
                        />
                        <el-dropdown
                          size="mini"
                          class="w65"
                          @command="handlePriceCommand"
                        >
                          <span class="el-dropdown-link">
                            应用
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="a"
                              >应用所有规格</el-dropdown-item
                            >
                            <el-dropdown-item command="b"
                              >仅应用未填写</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </template>
                      <template slot-scope="scope">
                        <el-input
                          class="w160"
                          type="number"
                          v-model.number="scope.row.attr_price"
                          size="mini"
                        />&nbsp;&nbsp;元
                      </template>
                    </el-table-column>
                    <el-table-column min-width="220" label="库存">
                      <template slot="header" slot-scope="scope">
                        <div class="header_label w80 whd-tright">库存</div>
                        <el-input
                          type="text"
                          v-model="attr_number"
                          class="w100"
                          size="mini"
                          style="margin: 0 8px"
                        ></el-input>
                        <el-dropdown
                          size="mini"
                          class="w65"
                          @command="handleNumberCommand"
                        >
                          <span class="el-dropdown-link">
                            应用
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="a"
                              >应用所有规格</el-dropdown-item
                            >
                            <el-dropdown-item command="b"
                              >仅应用未填写</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </template>
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model.number="scope.row.attr_number"
                          class="w160"
                          size="mini"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column min-width="220" label="积分数量">
                      <template slot="header" slot-scope="scope">
                        <div class="header_label w80 whd-tright">积分数量</div>
                        <el-input
                          type="text"
                          v-model="attr_points"
                          class="w100"
                          size="mini"
                          style="margin: 0 8px"
                        ></el-input>
                        <el-dropdown
                          size="mini"
                          class="w65"
                          @command="handlePointCommand"
                        >
                          <span class="el-dropdown-link">
                            应用
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="a"
                              >应用所有规格</el-dropdown-item
                            >
                            <el-dropdown-item command="b"
                              >仅应用未填写</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </template>
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model.number="scope.row.attr_points"
                          class="w160"
                          size="mini"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      min-width="220"
                      label="定制规格"
                      v-if="formdata.type === 3"
                    >
                      <template slot="header" slot-scope="scope">
                        <div class="header_label w80 whd-tright">定制规格</div>
                        <el-input
                          type="text"
                          v-model="attr_points"
                          class="w100"
                          size="mini"
                          style="margin: 0 8px"
                          v-if="false"
                        ></el-input>
                        <el-dropdown
                          size="mini"
                          class="w65"
                          @command="handlePointCommand"
                          v-if="false"
                        >
                          <span class="el-dropdown-link">
                            应用
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="a"
                              >应用所有规格</el-dropdown-item
                            >
                            <el-dropdown-item command="b"
                              >仅应用未填写</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </template>
                      <template slot-scope="scope">
                        <!-- <el-input
                                type="number"
                                v-model.number="scope.row.attr_points"
                                class="w160"
                                size="mini"
                        /> -->
                        <!-- <el-button @click="customBtnAdd(scope.row)">新增定制规格</el-button> -->
                        <span
                          style="color: #29a7f4"
                          @click="customBtnAdd(scope.row)"
                          >{{ scope.row.attr_make_name }}</span
                        >
                        <el-button
                          @click="selectcustomBtnAdd(scope.row, scope.$index)"
                        >
                          选择定制规格
                        </el-button>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column
                      label="库存编号"
                      >
                       <template slot-scope="scope">
                       <el-input v-model="scope.row.name" size="mini" placeholder="输入关键字搜索" />元
                      </template>
                    </el-table-column>-->
                  </el-table>
                </div>
                <!-- 分销设置 -->
                <div class="form_splititem">分销设置</div>
                <el-form-item label="商品提成">
                  <el-radio-group v-model="formdata.comm_type">
                    <el-radio
                      v-for="(item, index) in commtype"
                      :label="item.value"
                      :key="index"
                      >{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-input
                    type="text"
                    v-model="formdata.commission"
                    class="w160"
                    onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                  ></el-input>
                  {{ formdata.comm_type === 0 ? "元" : "%" }}
                </el-form-item>
                <el-form-item label="分销佣金设置">
                  <el-radio-group v-model="formdata.comm_set">
                    <el-radio
                      v-for="(item, index) in commset"
                      :label="item.value"
                      :key="index"
                      >{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  分销佣金比例(外部人员)
                  <span v-if="formdata.comm_set === 0">{{
                    formdata.outside
                  }}</span>
                  <el-input
                    v-else
                    v-model="formdata.comm_outside"
                    type="text"
                    class="w80"
                  ></el-input>
                  %
                </el-form-item>
                <el-form-item>
                  销售佣金比例(企业员工)：
                  <span v-if="formdata.comm_set === 0">{{
                    formdata.inside
                  }}</span>
                  <el-input
                    v-else
                    type="text"
                    v-model="formdata.comm_inside"
                    class="w80"
                  ></el-input>
                  %
                </el-form-item>
                <div class="form_splititem">配送</div>
                <el-form-item label="物流设置">
                  <el-radio-group v-model="formdata.logistics_set">
                    <el-radio
                      v-for="(item, index) in logisticsset"
                      :label="item.value"
                      :key="index"
                      >{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="快递运费"
                  v-if="formdata.logistics_set === 0"
                >
                  <el-radio-group v-model="formdata.shipping_set">
                    <el-radio
                      :label="item.value"
                      v-for="(item, index) in shippingset"
                      :key="index"
                    >
                      <div class="radio_item" v-if="item.value === 0">
                        {{ item.label }}
                        <el-input
                          type="text"
                          v-model="formdata.shipping_fee"
                          class="w160"
                          onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                        ></el-input>
                        <span>元(默认0元，即商品免运费)</span>
                      </div>
                      <div class="radio_item" v-if="item.value === 1">
                        {{ item.label }}
                        <el-select
                          v-model="formdata.fre_id"
                          class="w160"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in freoptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <el-button @click="queryfreight" class="ml10"
                          >刷新</el-button
                        >
                        <el-button @click="createfreight"
                          >新建运费模板</el-button
                        >
                      </div>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item v-if="formdata.logistics_set === 1">
                  <p>选择无需物流时，在购买时无需填写收货地址</p>
                  <p>可选择用户需要填写的内容:</p>
                  <el-checkbox v-model="formdata.shipping_name"
                    >用户姓名</el-checkbox
                  >
                  <el-checkbox v-model="formdata.shipping_phone"
                    >联系方式</el-checkbox
                  >
                </el-form-item>
              </div>
            </template>
            <div class="form_splititem">商品介绍</div>
            <el-form-item label="副标题">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4 }"
                v-model="formdata.goods_brief"
                maxlength="22"
                placeholder="请输入商品简介"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="商品详情" class="mt-10">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6 }"
                v-model="formdata.goods_desc"
                maxlength="400"
                placeholder="请输入商品详情文字介绍"
                show-word-limit
              ></el-input>
            </el-form-item>
            <div class="form_splititem">上架状态</div>
            <el-form-item>
              <el-radio-group v-model="formdata.is_sale">
                <el-radio
                  v-for="(item, index) in issale"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="form_splititem">爆款</div>
            <el-form-item>
              <el-radio-group v-model="formdata.is_hot">
                <el-radio
                  v-for="(item, index) in ishot"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="form_splititem">店铺推荐</div>
            <el-form-item>
              <el-radio-group v-model="formdata.is_recommend">
                <el-radio
                  v-for="(item, index) in isrecommend"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="form_splititem">限时优惠</div>
            <el-form-item>
              <el-radio-group v-model="formdata.is_cheap">
                <el-radio
                  v-for="(item, index) in ischeap"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="form_splititem">新品</div>
            <el-form-item>
              <el-radio-group v-model="formdata.is_new">
                <el-radio
                  v-for="(item, index) in isnew"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="savegood('form')"
                size="small"
                v-if="goodsType == 2"
                >复制新商品</el-button
              >
              <el-button type="primary" @click="savegood('form')" size="small"
                >保存</el-button
              >
              <el-button @click="goback" size="small">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="preview_wrap">
          <div class="preview_wrap_body">
            <p class="preview_wrap_body_title">实时预览效果</p>
            <div class="preview_wrap_body_list">
              <img
                src="/static/img/smallheader.jpg"
                alt=""
                class="header-top-linepic"
              />
              <div class="banner-list">
                <img
                  :src="
                    formdata.album[0]
                      ? formdata.album[0]
                      : 'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png'
                  "
                  alt=""
                />
                <span>1/{{ formdata.album.length }}</span>
              </div>
              <div class="preview_wrap_goods">
                <p class="preview_wrap_goods_name">{{ formdata.goods_name }}</p>
                <p class="preview_wrap_goods_info">
                  {{ formdata.goods_brief }}
                </p>
                <p class="preview_wrap_goods_price">
                  <span class="goods_priceline"
                    ><i>￥</i>{{ formdata.shop_price }}</span
                  ><span class="goods_shownumber">已售0件</span>
                </p>
              </div>
              <div class="preview_wrap_orth">
                <!--<p class="preview_wrap_p">-->
                <!--<span class="preview_wrap_p_sapn">优惠</span>-->
                <!--<span class="preview_wrap_p_sapn_line">全场98折，无使用门槛</span>-->
                <!--<span class="preview_wrap_p_sapn_llast">领取<i class="el-icon-arrow-right"></i></span>-->
                <!--</p>-->
                <p class="preview_wrap_p">
                  <span class="preview_wrap_p_sapn">选择</span>
                  <span class="preview_wrap_p_sapn_line">请选择型号</span>
                  <span class="preview_wrap_p_sapn_llast"
                    ><i class="el-icon-arrow-right"></i
                  ></span>
                </p>
                <p class="preview_wrap_p">
                  <span class="preview_wrap_p_sapn">参数</span>
                  <span class="preview_wrap_p_sapn_line">…</span>
                  <span class="preview_wrap_p_sapn_llast"
                    ><i class="el-icon-arrow-right"></i
                  ></span>
                </p>
              </div>
              <div class="preview_wrap_desc">
                <p class="preview_wrap_desc_title">产品介绍</p>
                <div class="preview_wrap_desc_info">
                  <div
                    class="preview_wrap_desc_info_word"
                    v-html="formdata.goods_desc"
                  ></div>
                  <!--<img src="/static/img/testimg.jpg" alt="">-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <corpper
      :visible.sync="corppervisible"
      v-if="corppervisible"
      @imgAddBack="imgAddBack"
      :imgSize="imgSize"
    ></corpper>
    <!-- 暂时注释，待接口调整后开启 -->
    <!-- <el-drawer  
      title="选择要关联的表单"
      direction="rtl"
      custom-class="custom-drawer"
      :visible.sync="drawer"
      >
        <div style="height: 100%; padding-bottom: 80px; overflow-y: auto">
          <div v-for="(item,index) in formList" :key="index" class="weui-cell" @click="selectForm(item.id, item.title)">
            <div class="weui-cell__hd">
              <i class="el-icon-success" :class="{'on':form_id===item.id}"></i>
            </div>
            <div class="weui-cell__hd">
              <div class="formtableimg">
                <img :src="item.back_img" />
              </div>              
            </div>
            <div class="weui-cell__bd">{{item.title}}</div>
          </div>
          <div class="pag_wrap">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="page.pagesize"
              :current-page="page.pageindex"
              :total="page.total"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>    
        </div>  
    </el-drawer>              -->
    <goodsSpecificationDialog
      :id="formdata.attr_cate"
      :visible.sync="specificationdialog"
      v-if="specificationdialog"
      @specificationsuccess="specificationsuccess"
    ></goodsSpecificationDialog>
    <goodsSelectSpecificationDialog
      :id="formdata.attr_cate"
      :visible.sync="selectspecdialog"
      v-if="selectspecdialog"
      @handleSelectSpecification="handleSelectSpecification"
    ></goodsSelectSpecificationDialog>
    <goodsCustomMakeListDialog
      :id="customSelecId"
      :visible.sync="customdialog"
      v-if="customdialog"
      :customMakeId="customSelecId"
      @pickCustomList="pickCustomList"
      @specificationsuccess="specificationsuccess"
    ></goodsCustomMakeListDialog>
    <!-- <customListSpecificationDialog
    :id="customSelecId" 
    :visible.sync="customdialog"
    v-if="customdialog"
    @specificationsuccess="specificationsuccess"
  ></customListSpecificationDialog> -->
    <goodsCustomListDialog
      :id="formdata.attr_cate"
      :visible.sync="customListShowFlag"
      v-if="customListShowFlag"
      @handleSelectCustomList="handleSelectCustomList"
    ></goodsCustomListDialog>
    <!-- 定制规格 -->
    <customSpecification
      ref="customSpecification"
      @subData="customSpecificationSubData"
    />
    <!-- <topImg /> -->
  </div>
</template>
<script>
import api from "@/api.js";
import uploaddrag from "@/components/uploaddrag.vue";
import corpper from "@/components/dialog/corpper.vue";
import goodsSpecificationDialog from "@/components/dialog/goodsSpecificationDialog.vue";
import goodsSelectSpecificationDialog from "@/components/dialog/goodsSelectSpecificationDialog.vue";
import goodsCustomMakeListDialog from "@/components/dialog/goodsCustomMakeListDialog.vue";
import goodsCustomListDialog from "@/components/dialog/goodsCustomListDialog.vue";
import goodsSpecification from "./components/goodsSpecification.vue";
import customSpecification from "./components/customSpecification.vue";
// import topImg from "./components/topImg.vue";

//
import draggable from "vuedraggable";
import { pagination } from "@/util/util.js";
import {
  goodtype,
  goodtypeNotAi,
  issale,
  ishot,
  isrecommend,
  ischeap,
  isnew,
  logisticsset,
  commset,
  commtype,
  isattr,
  ispay,
  showtype,
  shippingset,
} from "@/util/util.js";

export default {
  name: "addOrEditGoods",
  components: {
    uploaddrag,
    corpper,
    draggable,
    goodsSpecificationDialog,
    goodsCustomMakeListDialog,
    goodsSelectSpecificationDialog,
    goodsCustomListDialog,
    goodsSpecification,
    customSpecification,
    // topImg,
  },
  data() {
    return {
      customListShowFlag: false,
      aiMainData: [],
      customdialog: false,
      specificationdialog: false,
      selectspecdialog: false,
      data_: { token: sessionStorage.getItem("token") },
      imgSize: 0,
      corppervisible: false,
      currentindex: 0,
      titleinfo: "添加商品",
      uploadvideourl: api.uploadTokenVideo,
      goodtype: goodtype,
      goodtypeNotAi: goodtypeNotAi,
      issale: issale,
      ishot: ishot,
      isrecommend: isrecommend,
      ischeap: ischeap,
      isnew: isnew,
      logisticsset: logisticsset,
      commset: commset,
      commtype: commtype,
      isattr: isattr,
      ispay: ispay,
      showtype: showtype,
      shippingset: shippingset,
      formdata: {
        type: 0,
        goods_name: "",
        cat_id: [],
        cat_label: [],
        album: [],
        video: "",
        goods_detail: [],
        draw_img: [],
        order_desc: "",
        is_pay: 0,
        is_attr: 0,
        unit: "",
        cost: "",
        shop_price: "",
        goods_number: "",
        comm_type: 0,
        commission: "",
        comm_set: 0,
        comm_outside: 50,
        outside: "",
        comm_inside: 50,
        inside: "",
        logistics_set: 0,
        shipping_set: 0,
        shipping_fee: "",
        fre_id: "",
        make_id: "",
        make_data: "",
        shipping_name: "",
        shipping_phone: "",
        is_sale: 0,
        is_hot: 0,
        is_recommend: 0,
        is_cheap: 0,
        is_new: 0,
        show_type: "",
        show_price: "",
        reference: "",
        reference_price: "1万-10万",
        reference1: "参考价格",
        reference2: "价格面议",
        attr_cate: "",
        goods_brief: "",
        goods_desc: "",
        points: "",
        false_sales: "", // 初始化虚拟销量
      },
      cateoptions: [],
      freoptions: [],
      attrcateoptions: [],
      imageUrl: "",
      checkattrList: [],
      attrinfo: [],
      tablehead: [],
      attr_price: "",
      attr_number: "",
      attr_points: "",
      attrtable: [],
      id: "",
      ispayshow: false,
      lock: true,
      attremptycount: 0,
      defaultProps: {
        value: "id",
        label: "name",
        children: "child",
      },
      rules: {
        cat_id: [
          { required: true, message: "请选择商品分类", trigger: "blur" },
        ],
        goods_name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
        ],
        album: [
          { required: true, message: "请上传产品图片", trigger: "change" },
        ],
        goods_detail: [
          { required: true, message: "请上传产品详情图片", trigger: "change" },
        ],
        unit: [{ required: true, message: "请输入销售单位", trigger: "blur" }],
        goods_number: [
          { required: true, message: "请输入库存", trigger: "blur" },
        ],
        // attr_cate: [
        //   {required: true, message: "请选择商品类目", trigger: "change"}
        // ],
        shop_price: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
      },
      rules2: {
        cat_id: [
          { required: true, message: "请选择商品分类", trigger: "blur" },
        ],
        goods_name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
        ],
        album: [
          { required: true, message: "请上传产品图片", trigger: "change" },
        ],
        goods_detail: [
          { required: true, message: "请上传产品详情图片", trigger: "change" },
        ],
        draw_img: [
          { required: true, message: "请上传AI底图", trigger: "change" },
        ],
        unit: [{ required: true, message: "请输入销售单位", trigger: "blur" }],
        goods_number: [
          { required: true, message: "请输入库存", trigger: "blur" },
        ],
        // attr_cate: [
        //   {required: true, message: "请选择商品类目", trigger: "change"}
        // ],
        shop_price: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
      },
      rules3: {
        cat_id: [
          { required: true, message: "请选择商品分类", trigger: "blur" },
        ],
        goods_name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
        ],
        album: [
          { required: true, message: "请上传产品图片", trigger: "change" },
        ],
        goods_detail: [
          { required: true, message: "请上传产品详情图片", trigger: "change" },
        ],
        make_id: [
          { required: true, message: "请选择定制规格", trigger: "change" },
        ],
        unit: [{ required: true, message: "请输入销售单位", trigger: "blur" }],
        goods_number: [
          { required: true, message: "请输入库存", trigger: "blur" },
        ],
        // attr_cate: [
        //   {required: true, message: "请选择商品类目", trigger: "change"}
        // ],
        shop_price: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
      },
      goodsType: null,
      drawer: false, // 是否显示表单列表
      formList: [], // 表单列表
      form_id: "", // 选中的表单
      form_name: "", // 表单名称
      form_btn: "", // 按钮名称
      loading: true,
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total,
      },
      companyIndex: {},
      specificationList: [], //规格列表
      specification: "", //选中规格的id
      addSpecilShow: false, //新增规格的内容显示/隐藏
      specificationId: null, //编辑规格的id
    };
  },
  async created() {
    // 获取商品类目的规格列表
    this.getSpecificationList();
    //查询ai列表
    this.queryAiMainList();
    this.ispaysetshow();
    // 查询分类
    this.querycatelist();
    // 查询运费模板
    this.queryfreight();
    //查询定制类型
    this.querySpec();
    //查询人员接口
    this.queryMember();
    // 查询规格分类
    await this.queryattrcatelist();
    this.querydistribution();
    this.id = this.$route.query.id;
    this.goodsType = this.$route.query.type;
    if (this.id) {
      let titleinfo = "编辑商品";
      if (this.goodsType === 2) {
        titleinfo = "复制商品";
      }
      this.titleinfo = titleinfo;
      // 查询详情
      this.querydetail();
    }
    let companyIndex = localStorage.getItem("companyIndex");
    console.log(JSON.parse(companyIndex), "companyIndex");
    this.companyIndex = JSON.parse(companyIndex);
  },
  methods: {
    selectcustomBtn() {
      this.makeData = this.formdata.is_pay === 0 ? this.formdata.make_data : "";
      this.$refs.customSpecification.open();
      this.$refs.customSpecification.setMakeData(this.makeData);
      // this.customSpecificationShow = true;
    },
    // 定制规格弹窗的确认按钮
    customSpecificationSubData(data) {
      this.formdata.make_data = data;
      this.$refs.customSpecification.close();
      // this.customSpecificationShow = false;
      // formdata.is_pay === 0【0单规格   1多规格】
      console.log(data, 7777770);
    },
    _specificationsuccess(id) {
      this.specificationId = id ? id : this.specificationId;
      this.addSpecilShow = false;
      this.getSpecificationList(); // 获取商品类目的规格列表
    },
    // 新增规格
    _addSpecil() {
      this.addSpecilShow = true;
    },
    // 选中规格的Change
    specificationChange(e) {
      console.log(e, this.specificationList, 11111111);
      let item = this.specificationList.filter((item) => {
        return item.id == e;
      });
      console.log(item, 1001111);
      this.handleSelectSpecification(item[0]);
    },
    // 获取商品类目的规格列表
    getSpecificationList() {
      this.axios
        .post(api.goods_attr_index, {
          page: this.page.pageindex,
        })
        .then((res) => {
          if (res.data.code == 0) {
            console.log(res, 555000);
            this.specificationList = res.data.list;
            this.specificationChange(this.specificationId);
            // this.page.total = res.data.all_page;
          } else {
            this.page.total = 0;
          }
        });
    },
    //选择规格弹窗返回内容
    handleSelectSpecification(val) {
      console.log(val, "val");
      if (val) {
        this.attrtable = [];
        this.tablehead = [];
        this.attr_price = "";
        this.attr_number = "";
        this.queryattrlist(val.id);
        this.formdata.attr_cate_name = val.name;
      }
    },
    // 规格名称列表
    queryattrlist(cateid, checkids) {
      let params = {
        cate_id: cateid,
      };
      console.log(params, 996);
      this.axios
        .post(api.goods_attr_list, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.attrinfo = this.transformattr(response.data.list, checkids);
          } else {
          }
        })
        .catch((response) => {});
    },
    // ================================================================================================
    handleSelectCustomList(val) {
      console.log("handleSelectCustomList", val);
      let customListSelectIndex = this.customListSelectIndex;
      let attrtable = this.attrtable;
      if (val) {
        if (customListSelectIndex == -1) {
          this.formdata.make_id = val.id;
          this.formdata.make_name = val.name;
        } else {
          let item = attrtable[customListSelectIndex];
          item.attr_make_id = val.id;
          item.attr_make_name = val.name;
          this.$set(this.attrtable, customListSelectIndex, item);
        }
      }
    },
    aiMainChange(id) {
      console.log("id", id);
      let list = this.aiMainData;
      list.forEach((item, index) => {
        if (item.id === id) {
          this.queryAiMainDetail(id);
        }
      });
    },
    queryAiMainDetail(id) {
      this.axios
        .post(api.aiMainDetail, { goods_id: id })
        .then((response) => {
          if (response.data.code == 0) {
            let { goods_detail, goods_name, goods_thumb, video } =
              response.data.info;
            this.formdata.goods_name = goods_name;
            this.formdata.album = [goods_thumb];
            this.formdata.goods_detail = goods_detail.split(",");
            // this.formdata.video = video
          } else {
          }
        })
        .catch((response) => {});
    },
    queryAiMainList() {
      this.axios
        .post(api.aiMainList, {})
        .then((response) => {
          if (response.data.code == 0) {
            this.aiMainData = response.data.list;
            console.log(response, "response", this.aiMainData);
            // this.formdata.outside = response.data.info.comm_outside;
            // this.formdata.inside = response.data.info.comm_inside;
          } else {
          }
        })
        .catch((response) => {});
    },
    selectcustomBtnAdd(row, index) {
      console.log(row, "row", this.tablehead, this.attrtable, index);
      this.customId = "";
      //选中的序号
      this.customListSelectIndex = index;
      this.customListShowFlag = true;
      console.log(this.customdialog, "this.customdialog");
    },
    customBtnAdd(row) {
      console.log(row, "row");
      this.customSelecId = row.attr_make_id;
      // this.customId = '120'
      this.customdialog = true;
      console.log(this.customdialog, "this.customdialog");
    },
    // 勾选定制规格
    pickCustomList(e) {
      console.log(e);
    },
    // 添加类目成功回调
    specificationsuccess() {
      this.queryattrlist(this.formdata.attr_cate);
    },
    addSpecil() {
      this.id = "";
      this.specificationdialog = true;
    },
    selectSpecil() {
      this.selectspecdialog = true;
    },
    changetype() {
      this.formdata.cost = "";
      // this.formdata.shop_price = "";
    },
    // 删除多选分类
    removeTag(key) {
      let res = this.$refs.tree.getCheckedNodes();
      let ids = [];
      res.forEach((item, sindex) => {
        if (this.formdata.cat_label.indexOf(item.name) !== -1) {
          ids.push(item.id);
        }
      });
      this.formdata.cat_id = ids;
      this.$refs.tree.setCheckedKeys(ids);
    },
    getcheckedcate() {
      let catlabel = [];
      let catid = [];
      this.formdata.cat.forEach((item, sindex) => {
        if (this.formdata.cat_label === item.name) {
          index = sindex;
        }
      });
    },
    // 树型分类
    handleCheckChange() {
      let res = this.$refs.tree.getCheckedNodes();
      let arrLabel = [];
      let arr = [];
      res.forEach((item) => {
        arrLabel.push(item.name);
        arr.push(item.id);
      });
      this.formdata.cat_id = arr;
      this.formdata.cat_label = arrLabel;
    },
    // 获取分销规则
    querydistribution() {
      let params = {};
      this.axios
        .post(api.goods_distribution, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.formdata.outside = response.data.info.comm_outside;
            this.formdata.inside = response.data.info.comm_inside;
          } else {
          }
        })
        .catch((response) => {});
    },
    findSpecifitionName(val) {
      if (this.attrcateoptions) {
        this.attrcateoptions.forEach((item, sindex) => {
          if (item.id === val) {
            this.formdata.attr_cate_name = item.name;
          }
        });
      }
    },
    // 查询编辑详情
    querydetail() {
      let params = {
        goods_id: this.id,
      };
      let apiHttp_ = api.goods_detail;
      if (this.goodsType === 2) {
        apiHttp_ = api.copy_goods;
      }
      this.axios
        .post(apiHttp_, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.formdata.type = response.data.info.type;
            this.formdata.goods_name = response.data.info.goods_name;
            this.formdata.goods_number = response.data.info.goods_number;
            this.formdata.cat_id = response.data.info.cate_id;
            this.formdata.cat_label = response.data.info.cat_id;
            this.formdata.album = response.data.info.album || [];
            this.formdata.video = response.data.info.video;
            this.formdata.goods_detail = response.data.info.goods_detail || [];
            this.formdata.order_desc = response.data.info.order_desc;
            this.formdata.is_pay = response.data.info.is_pay;
            this.formdata.is_attr = response.data.info.is_attr;
            this.formdata.unit = response.data.info.unit;
            this.formdata.cost = response.data.info.cost;
            this.formdata.shop_price = response.data.info.shop_price;
            this.formdata.attr_cate = response.data.info.attr_cate;
            if (this.formdata.attr_cate) {
              this.findSpecifitionName(this.formdata.attr_cate);
            }
            this.formdata.show_price = response.data.info.show_price + "";
            this.formdata.show_type = response.data.info.show_type;
            this.formdata.points = response.data.info.points;
            this.formdata.false_sales = response.data.info.false_sales;
            if (this.formdata.show_type === 0) {
              this.formdata.reference1 = response.data.info.reference;
              this.formdata.reference_price =
                response.data.info.reference_price;
            } else if (this.formdata.show_type === 1) {
              this.formdata.reference2 = response.data.info.reference;
            }

            this.formdata.comm_type = response.data.info.comm_type;
            this.formdata.commission = response.data.info.commission;
            this.formdata.comm_set = response.data.info.comm_set;
            this.formdata.comm_outside = response.data.info.comm_outside;
            this.formdata.comm_inside = response.data.info.comm_inside;
            this.formdata.is_sale = response.data.info.is_sale;
            this.formdata.is_hot = response.data.info.is_hot;
            this.formdata.is_new = response.data.info.is_new;
            this.formdata.is_cheap = response.data.info.is_cheap;
            this.formdata.is_recommend = response.data.info.is_recommend;
            this.formdata.logistics_set = response.data.info.logistics_set;
            this.formdata.shipping_set = response.data.info.shipping_set;
            this.formdata.fre_id = response.data.info.fre_id;
            this.formdata.shipping_fee = response.data.info.shipping_fee;
            this.formdata.goods_brief = response.data.info.goods_brief;
            this.formdata.goods_desc = response.data.info.goods_desc;
            this.formdata.shipping_name =
              response.data.info.shipping_name === 0 ? false : true;
            this.formdata.shipping_phone =
              response.data.info.shipping_phone === 0 ? false : true;
            this.queryattrlist(
              this.formdata.attr_cate,
              this.getcheckattrids(response.data.attr)
            );
            this.createdittable(response.data.goods_attr);
            if (response.data.info.draw_img) {
              this.formdata.draw_img = [response.data.info.draw_img];
            }
            this.formdata.employee_id = response.data.info.employee_id;
            this.formdata.make_id = response.data.info.make_id;
            this.formdata.make_data = response.data.info.make_data;
          } else {
          }
        })
        .catch((response) => {});
    },
    // 编辑规格表格数据
    createdittable(goodsattrlist) {
      let result = [];
      this.tablehead = [];
      goodsattrlist.forEach((gitem, gindex) => {
        let rowdata = {
          attr_number: gitem.number,
          attr_price: gitem.price,
          attr_points: gitem.points,
          attr_make_id: gitem.attr_goods_make_image
            ? gitem.attr_goods_make_image.id
            : "",
          attr_make_name: gitem.attr_goods_make_image
            ? gitem.attr_goods_make_image.name
            : "",
        };
        if (gitem.attr_value && gitem.attr_value.length) {
          gitem.attr_value.forEach((aitem) => {
            if (gindex === 0) {
              this.tablehead.push({
                label: aitem.spec_name,
              });
            }
            rowdata[aitem.spec_name] = {
              id: aitem.item_id,
              name: aitem.item_name,
              spec_id: aitem.spec_id,
            };
          });
        }
        result.push(rowdata);
      });
      this.attrtable = result;
    },
    // 获取选中的规格id
    getcheckattrids(attr) {
      let ids = [];
      if (attr && attr.length) {
        attr.forEach((item) => {
          ids.push(item.id);
        });
      }
      return ids;
    },
    // 查询分类
    querycatelist() {
      let params = {};
      this.axios
        .post(api.goods_goods_cate_list, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.cateoptions = response.data.list || [];
          } else {
          }
        })
        .catch((response) => {});
    },
    // 多规格查询规格分类
    changeattr(val) {
      if (val === 1) {
        this.queryattrcatelist();
      }
    },
    // 查询规格分类列表
    queryattrcatelist() {
      let params = {};
      this.axios
        .post(api.goods_attr_cate_list, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.attrcateoptions = response.data.list || [];
          } else {
          }
        })
        .catch((response) => {});
    },
    // 多规格查询规格分类列表
    changeattrcate(val) {
      console.log("val", val);
      if (val) {
        this.attrtable = [];
        this.tablehead = [];
        this.attr_price = "";
        this.attr_number = "";
        this.queryattrlist(val);
      }
    },
    // 转换规格属性
    transformattr(list, checkids) {
      let res = [];
      if (list && list.length) {
        list.forEach((item) => {
          let attritem = {
            name: item.name,
            attr: item.attr,
            checkattrList: [],
          };
          let checkedattr = this.ischeckedattrid(item.attr, checkids);
          if (checkedattr.index !== -1) {
            attritem.checkattrList = [...checkedattr.ids];
          }
          res.push(attritem);
        });
      }
      return res;
    },
    // 是否存在选择的规格属性id
    ischeckedattrid(attr, checkids) {
      let result = {
        index: -1,
        ids: [],
      };
      if (attr && attr.length) {
        attr.forEach((item, index) => {
          if (checkids && checkids.length && checkids.indexOf(item.id) !== -1) {
            result.ids.push(item.id);
            result.index = index;
          }
        });
      }
      return result;
    },
    // 获取规格属性列表
    getattrtable() {
      let result = [];
      this.tablehead = [];
      if (this.attrinfo) {
        this.attrinfo.forEach((attritem) => {
          // 获取表头数据
          if (attritem.checkattrList.length) {
            this.tablehead.push({
              label: attritem.name,
            });
          }
          // 获取选中属性数据
          let res = [];
          attritem.attr.forEach((item) => {
            if (attritem.checkattrList.indexOf(item.id) !== -1) {
              let itemobj = {
                attr_number: "",
                attr_price: "",
                attr_points: "",
              };
              itemobj[attritem.name] = {
                id: item.id,
                name: item.name,
                spec_id: item.spec_id,
              };
              res.push(itemobj);
            }
          });
          if (res && res.length) {
            if (this.attrtable.length > 0) {
              this.attrtable.forEach((item) => {
                res.forEach((itema) => {
                  for (let i in item) {
                    if (
                      i === "attr_number" ||
                      i === "attr_price" ||
                      i === "attr_points"
                    ) {
                    } else {
                      for (let j in itema) {
                        if (i === j && item[i].name === itema[j].name) {
                          itema.attr_number = item.attr_number;
                          itema.attr_price = item.attr_price;
                          itema.attr_points = item.attr_points;
                        }
                      }
                    }
                  }
                });
              });
            }
            result.push(res);
          }
        });
      }

      this.getattrtabledata(result);
    },
    // 应用价格
    handlePriceCommand(command) {
      this.settingattrtable(command, "p");
    },
    // 应用库存
    handleNumberCommand(command) {
      this.settingattrtable(command, "n");
    },
    // 应用积分
    handlePointCommand(command) {
      this.settingattrtable(command, "s");
    },
    // 设置规格售价，库存
    settingattrtable(val, type) {
      this.attrtable.forEach((row) => {
        if (type == "p") {
          if (val === "a") {
            row.attr_price = this.attr_price;
          } else {
            if (row.attr_price === "") {
              row.attr_price = this.attr_price;
            }
          }
        }
        if (type == "n") {
          if (val === "a") {
            row.attr_number = this.attr_number;
          } else {
            if (row.attr_number === "") {
              row.attr_number = this.attr_number;
            }
          }
        }
        if (type == "s") {
          if (val === "a") {
            row.attr_points = this.attr_points;
          } else {
            if (row.attr_points === "") {
              row.attr_points = this.attr_points;
            }
          }
        }
      });
    },
    // 生成规格表格
    getattrtabledata(arr) {
      let result = [];
      let attr = this.attrtable;
      let thead = this.tablehead;
      arr.forEach((arritem) => {
        if (result.length == 0) {
          result = arritem;
        } else {
          let emptyresult = [];
          result.forEach((item) => {
            arritem.forEach((value) => {
              let obj = { ...item, ...value };
              if (item.attr_number) {
                obj.attr_number = item.attr_number;
              }
              if (item.attr_price) {
                obj.attr_price = item.attr_price;
              }
              if (item.attr_points) {
                obj.attr_points = item.attr_points;
              }
              emptyresult.push(obj);
            });
          });
          result = emptyresult;
        }
      });
      this.attrtable = result;
    },
    // 产品图片
    detelFn(index) {
      this.formdata.album.splice(index, 1);
    },
    indexLine(index) {
      this.currentindex = index;
    },
    datadragEnd(evt) {
      this.currentindex = evt.newIndex;
    },
    getdata(data) {},
    imgAddBack(option) {
      this.formdata.album.push(option);
    },
    showCropper() {
      this.corppervisible = true;
    },
    uploadalbum(val) {
      this.formdata.album = val;
    },
    // 产品详情
    uploaddetail(val) {
      this.formdata.goods_detail = val;
    },
    // 产品详情
    uploaddetaildraw(val) {
      this.formdata.draw_img = val;
    },
    handlevideoSuccess(res, file) {
      if (res.code === 0) {
        this.formdata.video = res.path;
      } else {
        this.$message.error(res.msg);
      }
      this.loadingStatus.close();
    },
    handlevideoRemove() {
      this.formdata.video = "";
    },
    beforevideoUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (["video/mp4"].indexOf(file.type) == -1) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传视频大小不能超过5MB哦!");
        return false;
      }
      this.loadingStatus = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
        customClass: "fontColor",
      });
    },
    // 查询运费模板
    queryfreight() {
      let params = {};
      this.axios
        .post(api.goods_freight, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.freoptions = response.data.list || [];
          } else {
          }
        })
        .catch((response) => {});
    },
    // 查询定制类型
    querySpec() {
      let params = {};
      this.axios
        .post(api.make_spe_pull, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.spections = response.data.data || [];
            console.log(this.spections, "spection");
          } else {
          }
        })
        .catch((response) => {});
    },
    // 查询定制类型
    queryMember() {
      let params = {};
      this.axios
        .post(api.make_member_get, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.membertions = response.data.data || [];
            console.log(this.membertions, "spection");
          } else {
          }
        })
        .catch((response) => {});
    },
    // 保存
    savegood(formName) {
      console.log(this.formdata, "fromdata");
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let params = {};
          if (this.formdata.type === 1) {
            params = this.getvgoodparams();
          }
          if (
            this.formdata.type === 0 ||
            this.formdata.type === 2 ||
            this.formdata.type === 3
          ) {
            params = this.getgoodparams();

            // 支持线上支付并且多规格项判断是否必填;
            if (this.formdata.is_pay === 0 && this.formdata.is_attr === 1) {
              if (params.attr_data && params.attr_data.length === 0) {
                this.$message({
                  message: "请选择商品类目项",
                  type: "warning",
                });
                return false;
              } else {
                if (this.attremptycount > 0) {
                  this.$message({
                    message: "售价库存不能为空",
                    type: "warning",
                  });
                  return false;
                }
              }
            }
          }
          console.log("this.formdata", this.formdata);

          if (
            !this.formdata.cat_id ||
            this.formdata.cat_id.length == 0 ||
            this.formdata.cat_id.toString() == ""
          ) {
            this.$message({
              message: "商品分类不能为空",
              type: "warning",
            });
            return false;
          }

          if (this.formdata.type === 2) {
            params.draw_img = this.formdata.draw_img.toString("");
          }
          if (this.formdata.type === 3) {
            console.log(
              "this.formdata.type",
              this.formdata.type,
              this.formdata.is_attr,
              "this.formdata.is_attr"
            );
            if (!this.checkMakeId()) {
              return;
            }
          }
          console.log("end");
          if (this.formdata.type === 3) {
            params.make_id = this.formdata.make_id;
            params.employee_id = this.formdata.employee_id;
          }

          // 线上支付商品需先配置微信支付 必须是实体商品 跟 选择线上支付
          if (
            this.formdata.is_pay === 0 &&
            (this.formdata.type === 0 ||
              this.formdata.type === 2 ||
              this.formdata.type === 3)
          ) {
            let res = await this.ispayset();
            if (res.data.code == 0) {
              if (res.data.info.is_set === 0) {
                this.$message({
                  type: "error",
                  message: "线上支付商品需先配置微信支付",
                });
                return false;
              }
            }
          }
          console.log("params", params);
          if (this.lock) {
            this.lock = false;
            if (this.id) {
              if (this.goodsType === 2) {
                this.submitsave(params);
              } else {
                this.submiteditsave(params);
              }
            } else {
              this.submitsave(params);
            }
          }
        } else {
          return false;
        }
      });
    },
    //检查多规格定制是否存在
    checkMakeId() {
      let flag = true;
      //单规格
      if (this.formdata.is_attr === 0 && !this.formdata.make_id) {
        flag = false;
      }
      //双规格
      if (this.formdata.is_attr === 1) {
        let attrtable = this.attrtable;
        console.log(attrtable, "attrtable");
        if (attrtable.length > 0) {
          attrtable.forEach((item) => {
            if (!item.attr_make_id && flag) {
              flag = false;
            }
          });
        }
      }
      // setitem.attr_value = {};
      // if (this.tablehead
      // let tablehead = this.tablehead
      if (!flag) {
        this.$message({
          message: "请选择定制类型",
          type: "warning",
        });
      }
      return flag;
    },
    // 是否设置支付信息
    ispayset() {
      let params = {};
      return this.axios.post(api.companyadmin_company_pay, params);
    },
    // 是否显示配置标签
    async ispaysetshow() {
      let res = await this.ispayset();
      if (res.data.code == 0) {
        this.ispayshow = res.data.info.is_set === 0 ? true : false;
      }
    },
    // 虚拟商品
    getvgoodparams() {
      let params = {
        type: this.formdata.type,
        goods_name: this.formdata.goods_name,
        cat_id: this.formdata.cat_id,
        album: this.formdata.album.join(","),
        video: this.formdata.video,
        goods_detail: this.formdata.goods_detail.join(","),
        order_desc: this.formdata.order_desc,
        is_sale: this.formdata.is_sale,
        is_hot: this.formdata.is_hot,
        is_recommend: this.formdata.is_recommend,
        is_cheap: this.formdata.is_cheap,
        is_new: this.formdata.is_new,
        goods_brief: this.formdata.goods_brief,
        goods_desc: this.formdata.goods_desc,
      };
      return params;
    },
    // 实体商品
    getgoodparams() {
      let params = {
        type: this.formdata.type,
        // make_data: JSON.stringify(this.formdata.make_data),
        make_data: this.formdata.make_data,
        goods_name: this.formdata.goods_name,
        cat_id: this.formdata.cat_id,
        album: this.formdata.album.join(","),
        video: this.formdata.video,
        goods_detail: this.formdata.goods_detail.join(","),
        order_desc: this.formdata.order_desc,
        is_sale: this.formdata.is_sale,
        is_hot: this.formdata.is_hot,
        is_recommend: this.formdata.is_recommend,
        is_cheap: this.formdata.is_cheap,
        is_new: this.formdata.is_new,
        goods_brief: this.formdata.goods_brief,
        goods_desc: this.formdata.goods_desc,
        is_pay: this.formdata.is_pay,
      };
      // 仅线上展示
      if (this.formdata.is_pay === 1) {
        params.show_type = this.formdata.show_type;
        if (this.formdata.show_type === 0) {
          params.reference = this.formdata.reference1;
          params.reference_price = this.formdata.reference_price;
        } else {
          params.reference = this.formdata.reference2;
          params.reference_price = "";
        }
      }
      // 支持线上支付
      if (this.formdata.is_pay === 0) {
        params.is_attr = this.formdata.is_attr;
        params.unit = this.formdata.unit;
        params.false_sales = this.formdata.false_sales;

        // 单规格
        if (this.formdata.is_attr === 0) {
          params.cost = this.formdata.cost;
          params.shop_price = this.formdata.shop_price;
          params.show_price = this.formdata.show_price;
          params.goods_number = this.formdata.goods_number;
          params.points = this.formdata.points;
        }
        // 多规格
        if (this.formdata.is_attr === 1) {
          params.attr_cate = this.formdata.attr_cate;
          params.cost = this.formdata.cost;
          params.attr_data = this.getattrsetting();
        }

        // 提成
        params.comm_type = this.formdata.comm_type;
        params.commission = this.formdata.commission;

        // 分销
        params.comm_set = this.formdata.comm_set;

        if (this.formdata.comm_set === 1) {
          params.comm_outside = this.formdata.comm_outside;
          params.comm_inside = this.formdata.comm_inside;
        }
        // 物流
        params.logistics_set = this.formdata.logistics_set;
        if (this.formdata.logistics_set === 0) {
          params.shipping_set = this.formdata.shipping_set;
          if (this.formdata.shipping_set === 0) {
            params.shipping_fee = this.formdata.shipping_fee;
            params.fre_id = "";
          }
          if (this.formdata.shipping_set === 1) {
            params.fre_id = this.formdata.fre_id;
            params.shipping_fee = "";
          }
        }
        if (this.formdata.logistics_set === 1) {
          params.shipping_name = this.formdata.shipping_name === true ? 1 : 0;
          params.shipping_phone = this.formdata.shipping_phone === true ? 1 : 0;
        }
      }
      return params;
    },
    // 多规格设置数据参数
    getattrsetting() {
      let result = [];
      this.attremptycount = 0;
      if (this.attrtable && this.attrtable.length > 0) {
        this.attrtable.forEach((item) => {
          if (
            item.attr_price === "" ||
            item.attr_number === "" ||
            item.attr_number === ""
          ) {
            this.attremptycount++;
          }
          var setitem = {
            attr_price: item.attr_price,
            attr_number: item.attr_number,
            attr_points: item.attr_points,
            attr_make_id: item.attr_make_id,
          };
          setitem.attr_value = {};
          if (this.tablehead && this.tablehead.length) {
            this.tablehead.forEach((hitem) => {
              setitem.attr_value[item[hitem.label].spec_id] =
                item[hitem.label].id;
            });
          }
          result.push(setitem);
        });
      }
      return result;
    },
    // 提交保存
    submitsave(params) {
      this.axios
        .post(api.goods_add, params)
        .then((response) => {
          this.lock = true;
          if (response.data.code == 0) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.goback();
          }
        })
        .catch((response) => {
          this.lock = true;
        });
    },
    // 提交保存
    submiteditsave(params) {
      console.log(params, "params1440=*=*=**==**=*=*=*=**==**==*=*");
      // goodsType 1 编辑 2 复制商品
      let message_ = "保存成功";
      if (this.goodsType === 2) {
        message_ = "复制成功";
      }
      params.goods_id = this.id;
      this.axios
        .post(api.goods_edit, params)
        .then((response) => {
          this.lock = true;
          if (response.data.code == 0) {
            this.$message({
              message: message_,
              type: "success",
            });
            this.goback();
          }
        })
        .catch((response) => {
          this.lock = true;
        });
    },
    goback() {
      this.$router.go(-1);
    },
    // 前往配置
    goset() {
      let routeData = this.$router.resolve({
        name: "payment",
      });
      window.open(routeData.href, "_blank");
    },
    // 前往运费模板
    createfreight() {
      let routeData = this.$router.resolve({
        name: "createFreight",
      });
      window.open(routeData.href, "_blank");
    },
    // 暂时注释，待接口调整后开启
    // 弹出表单列表
    // openFormList() {
    //   this.drawer = true;
    //   this.getFormData();
    // },
    // getFormData() {
    //   this.axios
    //     .post(api.companyadmin_form_list, {page: this.page.pageindex})
    //     .then(response => {
    //       if (response.data.code == 0) {
    //         this.formList = response.data.list;
    //         this.page.total = response.data.all_page;
    //       }
    //     })
    //     .catch(() => {});
    // },
    // selectForm(id, name) {
    //   this.form_id = id;
    //   this.form_name = name;
    // },
    // deleteForm() {
    //   this.form_id = "";
    //   this.form_name = "";
    // },
    // handleCurrentChange(val) {
    //   this.page.pageindex = val;
    //   this.getFormData();
    // },
    // handleClose() {
    //   this.drawer = false;
    // }
  },
};
</script>
<style scoped>
.goodsSpecification {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #cccccc;
}
</style>
